<template>
  <section v-on:click="sectionClicked" class="features"
    :class="{hasAddr: section.config.displayAddress
    || section.config.displaySocmed || section.config.displayNewsletter}">
    <div class="cnt">
      <div class="sectionHeader" v-if="section.title[lang] || section.descriptions[lang]">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
      </div>
      <div class="formCnt" :class="{hasAddr: section.config.displayAddress
        || section.config.displaySocmed || section.config.displayNewsletter}">
        <form v-on:submit.prevent="handleSubmit">
          <div class="fieldGroup" v-for="(item, i) in section.items" :key="`f${i}`"
            :class="{hasError: item.error && item.error[lang]}">
            <label v-if="item.label && item.label[lang]">{{item.label[lang]}}
              <template v-if="item.isRequired">*</template></label>
            <div class="fieldCnt" v-if="['text', 'email', 'date'].includes(item.type)">
              <input :type="item.type" class="field" :placeholder="item.placeholder[lang]"
                v-model="item.model[lang]" v-on:input="item.error[lang] = null">
            </div>
            <div class="fieldCnt" v-else-if="item.type === 'textarea'">
              <textarea class="field" :placeholder="item.placeholder[lang]" rows="3"
                v-model="item.model[lang]" v-on:input="item.error[lang] = null"></textarea>
            </div>
            <div class="fieldCnt" v-else-if="item.type === 'checkbox'">
              <div class="ckCnt" v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                <label>
                  <input type="checkbox" v-model="opt.selected"
                    v-on:change="item.error[lang] = null">
                  <span class="checkmark"></span>
                  {{opt.label}}
                </label>
              </div>
            </div>
            <div class="fieldCnt" v-else-if="['select', 'dropdown'].includes(item.type)">
              <select class="field" v-model="item.model[lang]"
                v-on:change="item.error[lang] = null">
                <option value="__placeholder__" v-if="item.placeholder[lang]">
                  {{item.placeholder[lang]}}
                </option>
                <option v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                  {{opt.label}}
                </option>
              </select>
            </div>
            <div class="fieldError" v-if="item.error && item.error[lang]">
              {{item.error[lang]}}
            </div>
          </div>
          <button class="btn primary" type="submit">
            <span v-if="lang === 'en'">Submit</span>
            <span v-if="lang === 'id'">Kirimkan</span>
          </button>
        </form>
        <div class="addrCnt">
        <div class="footer-widget" v-if="section.address">
          <div class="widget-content">
            <h3 class="widget-title title">{{section.address.label[lang]}}</h3>
            <div class="widget-content d-flex notranslate address">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-location-dot" class="text-primary" />
              </div>
              {{section.address.address[lang]}}
            </div>
            <div class="widget-content d-flex mt-2 notranslate"
              v-for="(item, i) in section.address.phone" :key="`ph${i}`">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-phone" class="text-primary" />
              </div>
              <a :href="`tel:${item.value}`">{{item.value}}</a>
            </div>
            <div class="widget-content d-flex mt-2 notranslate"
              v-for="(item, i) in section.address.email" :key="`em${i}`">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-envelope" class="text-primary" />
              </div>
              <a :href="`mailto:${item.value}`">{{item.value}}</a>
            </div>
          </div>
        </div>
        <div class="footer-widget" v-if="section.socmed">
          <div class="widget-content">
            <h3 class="widget-title title">{{section.socmed.label[lang]}}</h3>
            <div class="media-sosial-cta">{{section.socmed.desc[lang]}}</div>
            <div class="media-sosial-icon-container mt-2">
              <div class="media-sosial-icon" v-for="(item, i) in section.socmed.socmed" :key="`sc${i}`">
                <a :href="item.url" target="_blank" :title="item.name">
                  <img v-if="item.media" :src="item.media.imageSm">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-widget" v-if="section.newsletter">
          <div class="widget-content">
            <div class="subscription" v-if="section.newsletter && section.newsletter.enableSubscription">
              <h3 class="widget-title title">{{section.newsletter.subscriptionLabel[lang]}}</h3>
              <button class="btn primary" v-on:click="openSubscribe">
                {{section.newsletter.subscriptionButton[lang]}}
              </button>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
    <Subscription ref="subscription"/>
    <ThankYou ref="thankYou"/>
  </section>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';
import Subscription from '@/components/Subscription.vue';

export default {
  name: 'home',
  props: ['section'],
  components: { ThankYou, Subscription },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    openSubscribe() {
      this.$refs.subscription.open(this.section.newsletter);
    },
    resetForm() {
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (['select', 'dropdown'].includes(item.type)) {
          item.model[this.lang] = '__placeholder__';
        } else if (item.type === 'checkbox') {
          // eslint-disable-next-line
          for (const opt of item.options) {
            opt.selected = false;
          }
        } else {
          item.model[this.lang] = '';
        }
      }
    },
    handleSubmit() {
      const formData = {
        title: this.section.title,
        descriptions: this.section.descriptions,
        emailVerification: this.section.config.emailVerification,
        lang: this.lang,
        items: [],
      };
      // eslint-disable-next-line
      for (const item of this.section.items) {
        if (item.isRequired) {
          if (['select', 'dropdown'].includes(item.type)) {
            if (!item.model[this.lang] || item.model[this.lang] === '__placeholder__') {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (item.type === 'checkbox') {
            let hasSelected = false;
            // eslint-disable-next-line
            for (const opt of item.options) {
              if (opt.selected) hasSelected = true;
            }
            if (!hasSelected) {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (!item.model[this.lang] || item.model[this.lang].trim() === '') {
            item.error.id = 'Masukan harus diisi';
            item.error.en = 'Field is required';
            return;
          }
        }

        formData.items.push({
          type: item.type,
          isRequired: item.isRequired,
          label: item.label[this.lang],
          model: item.model[this.lang],
          placeholder: item.placeholder[this.lang],
          options: item.options,
        });
      }
      this.$refs.thankYou.open({
        loading: true,
        title: this.section.config.thankYouTitle[this.lang],
        desc: this.section.config.thankYouDesc[this.lang],
      });
      this.$http.post(this.$config.uri('user/form/submit'), formData).then((r) => {
        this.$refs.thankYou.stopLoading();
        this.resetForm();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    // eslint-disable-next-line
    for (const item of this.section.items) {
      if (['select', 'dropdown'].includes(item.type) && item.placeholder[this.lang]) {
        item.model[this.lang] = '__placeholder__';
      }
    }
  },
};
</script>

<style scoped lang="scss">
.features.hasAddr{
  padding: 30px 0 120px;
}
.formCnt{
  max-width: 640px;
  margin: 0 auto;
  &.hasAddr{
    max-width: none;
    display: flex;
    @media (max-width: 920px) {
      display: block;
    }
    form{
      width: calc(100% - 540px);
      box-sizing: border-box;
      @media (max-width: 1060px) {
        width: calc(100% - 480px);
      }
      @media (max-width: 920px) {
        width: auto;
      }
    }
    .addrCnt{
      width: 540px;
      box-sizing: border-box;
      padding-left: 120px;
      @media (max-width: 1060px) {
        padding-left: 60px;
        width: 480px;
      }
      @media (max-width: 920px) {
        width: auto;
        padding: 50px 0 0;
        margin-top: 60px;
        border-top: #ccc 1px solid;
      }
      .footer-widget{
        margin: 0 0 30px;
      }
      .widget-content{
        margin: 0 0 10px;
        .widget-title{
          margin: 0 0 10px;
          font-size: 24px;
        }
        .me-2{
          margin-right: 14px;
          color: #008552;
        }
        .btn{
          display: inline-block;
          width: auto;
        }
      }
      .media-sosial-icon-container{
        display: flex;
      }
      .media-sosial-icon{
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        a{
          transition: 600 all ease-in;
        }
        .svg-inline--fa {
          vertical-align: initial;
        }
        img{
          display: block;
          height: 32px;
          border-radius: 3px;
        }
      }
      .d-flex {
        display: flex;
      }
    }
  }
  .fieldGroup{
    .fieldCnt{
      position: relative;
      .ckCnt{
        display: block;
        label{
          text-transform: none;
          font-size: 16px;
          color: #444;
          font-weight: 500;
          display: inline-block;
          position: relative;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding-left: 40px;
          height: 36px;
          .checkmark{
            position: absolute;
            top: 50%; left: 0;
            height: 24px; width: 24px;
            transform: translateY(-50%);
            border: #ccc 2px solid;
            box-sizing: border-box;
            border-radius: 5px;
            transition: all .3s ease;
            &:after{
              content: "";
              position: absolute;
              display: none;
              left: 6px;
              top: 0px;
              width: 5px;
              height: 14px;
              border: solid white;
              border-width: 0 3px 3px 0;
              -webkit-transform: rotate(45deg);
              -ms-transform: rotate(45deg);
              transform: rotate(45deg);
            }
          }
          &:hover{
            .checkmark{
              border-color: #008552;
            }
          }
          input{
            position: absolute;
            opacity: 0;
            cursor: pointer;
            height: 0;
            width: 0;
            &:checked ~ .checkmark {
              background-color: #008552;
              border-color: #008552;
            }
            &:checked ~ .checkmark:after {
              display: block;
            }
          }
        }
      }
    }
    &.hasError{
      .fieldCnt{
        .ckCnt{
          label{
            .checkmark{
              border-color: red;
            }
          }
        }
      }
    }
  }
  .btn{
    width: 100%;
    display: block;
    font-size: 18px;
    font-weight: 500;
    padding: 14px 20px;
  }
}
</style>
